import React, { useEffect } from "react";
import { Stack, Typography } from "@mui/material";

import {
  HubCancelSubmitGroup,
  HubDialogContent,
  HubHookFormWrapper,
} from "../../components";
import {
  useDeleteMaterial,
  useGetMaterialDetails,
} from "../../hooks";
import { useDialogContext } from "../HubDialogWrapper";

const DeleteMaterialContent = () => {
  const { onClose, open } = useDialogContext();
  const id = typeof open === "number" ? open : null;

  const { data: material } = useGetMaterialDetails(id);
  const { mutate: deleteMaterial, isLoading, isSuccess } = useDeleteMaterial();

  useEffect(() => {
    if (isSuccess) onClose();
  }, [isSuccess]);

  const onSubmit = () => {
    if (id) deleteMaterial(id);
  };

  return (
    <HubDialogContent largePadding>
      <HubHookFormWrapper onSubmit={onSubmit}>
        <Stack gap="20px" alignItems="center" textAlign="center">
          <Typography variant="h6">Delete Material</Typography>
          <Typography variant="caption">
            Are you sure you want to delete{" "}
            <strong>{material?.name || "this material"}</strong>? Materials
            referenced in any part recipe (instructions, dips, foundry, labor,
            line items, or quotes) cannot be deleted.
          </Typography>
          <HubCancelSubmitGroup
            disabled={isLoading || !id}
            isLoading={isLoading}
            label="Delete"
          />
        </Stack>
      </HubHookFormWrapper>
    </HubDialogContent>
  );
};

export default DeleteMaterialContent;
